export const routeContratos = (routes, checkAuth) => {
    routes.push(
        {
            path: "/contratos",
            component: () =>
                import(/* webpackChunkName: "contratos" */ "../pages/cadastros/Contratos.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/contrato",
            component: () =>
                import(/* webpackChunkName: "contrato" */ "../pages/cadastros/contratos/Index.vue"),
            beforeEnter: checkAuth,
            children: [
                {
                    path: "novo/:cliente_id",
                    component: () =>
                        import(/* webpackChunkName: "contrato_add" */ "../pages/cadastros/contratos/ContratoAdd.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "add/:id",
                    component: () =>
                        import(/* webpackChunkName: "contrato_add" */ "../pages/cadastros/contratos/ContratoAdd.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "comandos/:id",
                    component: () =>
                        import(/* webpackChunkName: "contrato_comando" */ "../pages/cadastros/contratos/ContratoComando.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "portas/:id",
                    component: () =>
                        import(/* webpackChunkName: "contrato_portas" */ "../pages/cadastros/contratos/ContratoPortas.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "traceroute/:id",
                    component: () =>
                        import(/* webpackChunkName: "contrato_traceroute" */ "../pages/cadastros/contratos/ContratoTraceRoute.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "logs/:id",
                    component: () =>
                        import(/* webpackChunkName: "contrato_logs" */ "../pages/cadastros/contratos/ContratoLogs.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "atendimentos/:id",
                    component: () =>
                        import(/* webpackChunkName: "contrato_atendimentos" */ "../pages/cadastros/contratos/ContratoAtendimentos.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "boleto/:id",
                    component: () =>
                        import(/* webpackChunkName: "contrato_boleto" */ "../pages/cadastros/contratos/ContratoBoleto.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "financeiro/:id",
                    component: () =>
                        import(/* webpackChunkName: "contrato_financeiro" */ "../pages/cadastros/contratos/ContratoFinanceiro.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "cacontrol/:id",
                    component: () =>
                        import(/* webpackChunkName: "contrato_cacontrol" */ "../pages/cadastros/contratos/ContratoCaControl.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "usuarios/:id",
                    component: () =>
                        import(/* webpackChunkName: "contrato_usuario" */ "../pages/cadastros/contratos/ContratoUsuario.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "usuario/:id",
                    component: () =>
                        import(/* webpackChunkName: "contrato_usuario_add" */ "../pages/cadastros/contratos/ContratoUsuarioAdd.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "usuario/:id/:usuario_id",
                    component: () =>
                        import(/* webpackChunkName: "contrato_usuario_add" */ "../pages/cadastros/contratos/ContratoUsuarioAdd.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "hotspots/:id",
                    component: () =>
                        import(/* webpackChunkName: "contrato_hotspot" */ "../pages/cadastros/contratos/ContratoHotspot.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "onu/:id",
                    component: () =>
                        import(/* webpackChunkName: "contrato_onu" */ "../pages/cadastros/contratos/ContratoOnu"),
                    beforeEnter: checkAuth
                }
            ]
        },
        {
            path: "/contrato/by-ref/:ref_id",
            component: () =>
                import(/* webpackChunkName: "contrato_add" */ "../pages/cadastros/contratos/ContratoAdd.vue"),
            beforeEnter: checkAuth
        },

        {
            path: "/contrato/integracao/:token/:ref_id",
            component: () =>
                import(/* webpackChunkName: "contrato_add" */ "../pages/cadastros/contratos/ContratoAdd.vue")
        },
        {
            path: "/integracao/:token/:ref_id",
            component: () =>
                import(/* webpackChunkName: "contrato_add" */ "../pages/cadastros/contratos/ContratoAdd.vue")
        }
    );
};
